import { getIngredientType } from 'helpers/ingredientHelper';
import { ingredientTypeMap } from 'constants/ingredientType';
import TypeItem, { UOM_KEY_UNKNOWN } from 'records/TypeItem';
import { List } from 'immutable';
import { ingredientErrorType } from '../constants/ingredientErrorTypes';

/**
 * Filter relevant unit-types
 * @param {Record} ingredient ingredient immutable record 
 * @param {List} unitTypes unit-types immutable record
 * @returns {List} relevant unit-types
 */
export const getMatchingUnits = (ingredient, unitTypes) => {
    if (!ingredient) {
        return new List();
    }

    const ingredientType = getIngredientType(ingredient.toJS());
    const amountUnitTextKey = ingredient.get('amountUnitTextKey');
    const baseUnitTextKey = ingredient.get('baseUnitTextKey');
    const isUnitMismatch = ingredient.get('errorType') && ingredient.get('errorType').includes(ingredientErrorType.UNIT_MISMATCH);

    let filteredItems;
    if (isUnitMismatch) {
        filteredItems = TypeItem.getWeightUnitsByTextKey(unitTypes, baseUnitTextKey);
    } else {
        filteredItems = getFinalizedIngredientType(ingredientType, amountUnitTextKey, baseUnitTextKey, unitTypes)
    }
    

    var distinctItems = filteredItems.groupBy(item => item.id).map(item => item.first()).toList();

    // if don't have value noOfEaches, then filter ea unit from list
    if (!ingredient.get('noOfEaches') > 0) {
        if (baseUnitTextKey !== 'ea') {
            distinctItems = TypeItem.filterOutOneType(distinctItems, 'ea');
        }
    }

    return TypeItem.sortTypeItemsByName(distinctItems);
}

const getFinalizedIngredientType = (ingredientType, amountUnitTextKey, baseUnitTextKey, unitTypes) => {
    switch (ingredientType) {
        case ingredientTypeMap.CUSTOM_INGREDIENTS:
            if (amountUnitTextKey === UOM_KEY_UNKNOWN && baseUnitTextKey === UOM_KEY_UNKNOWN) {
                return TypeItem.getDefaultWeightUnits(unitTypes, amountUnitTextKey);
            }
            return TypeItem.getWeightUnitsByTextKey(
                unitTypes, 
                amountUnitTextKey !== UOM_KEY_UNKNOWN ? amountUnitTextKey : baseUnitTextKey
            );

        case ingredientTypeMap.SYSCO_PRODUCTS:
            return TypeItem.getWeightUnitsByTextKey(
                unitTypes, 
                amountUnitTextKey === 'ea' ? baseUnitTextKey : amountUnitTextKey
            );

        case ingredientTypeMap.BATCH_RECIPES:
        default:
            return TypeItem.getWeightUnitsByTextKey(unitTypes, baseUnitTextKey);
    }
}